import React, { useState,useEffect } from "react";
// import Input from '../../Components/Atoms/Input/Input'
import {
  
  FormDropdown,
  FormField,
   
} from "../../Components/Molecules/FormField/FormField";
import ErrorLabel from "../../Components/Atoms/ErrorLabel/ErrorLabel";
import thosuandSeparator from "../../Helpers/thousandSeparator";
import {
  
  PrimaryButton
} from "../../Components/Atoms/Button/Button";
import HBar from "../../Components/Bars/Bars";
import _ from "lodash"
import { get_master_data} from "../../Enums/api_constunts"
import { postMethod } from "../../Helpers/services";

export const OtherIncome = ({ formik, HBarLabel,loanFormDetails,setTotalSalaryNetIncome ,setTotalOtherIncome,calculateSpendingPercentage }) => {
    const otherIncomeOptions = [
        {
          id: true,
          label: "Yes",
        },
        {
          id: false,
          label: "No",
        },
      ];
    const [other_income_list, setIncomeFields] = useState([ { incomeType: "", amount: "" }]);

  const handleAddIncomeField = () => {
    setIncomeFields([...other_income_list, { incomeType: "", amount: "" }]);
  };

  const handleRemoveIncomeField = (index) => {
    // Create a new list without the removed item
    const updatedList = other_income_list.filter((_, i) => i !== index);
    setIncomeFields(updatedList);

    // Calculate new total after removing the item
    const newTotal = updatedList.reduce((sum, item) => {
      const amount = parseFloat(item.amount) || 0;
      return sum + amount;
    }, 0);
    // remove the index valued from formik other_income_list
    formik.setFieldValue("other_income_list", updatedList);

    // Update the formik value with the new total
    formik.setFieldValue("total_other_income_per_month", newTotal.toString());
  };

  const handleFieldChange = (index, field, value) => {
    const updatedFields = other_income_list.map((item, i) =>
      i === index ? { ...item, [field]: value } : item
    );
    setIncomeFields(updatedFields);
    formik.setFieldValue(`other_income_list[${index}].${field}`, value);
  };

  const handleChange = (e ,type="grossSalary") => {
    const rawValue = e.target.value.replace(/,/g, "");
    const formattedValue = thosuandSeparator(rawValue);
    formik.setFieldValue(type, e.target.value);
  };
  const updateTotalOtherIncomeAmount = ()=>{
    console.log(JSON.stringify(formik.values))
    let amount = 0;
   
    other_income_list.forEach((item)=>{
      console.log(_.get(item,"incomeType",""))
      if(_.get(item,"amount",0) && _.get(item,"incomeType","").trim() !='' ){
        
        amount =amount+parseInt(item["amount"])
      } })
  
      console.log(amount)
     setTotalOtherIncome(amount)    
     formik.setFieldValue("total_other_income_per_month",amount)
     
    //  if(_.has(formik, "values.netSalary")){
    //   let netSalary =  parseFloat(formik.values.netSalary);
    //   formik.setFieldValue("total_income_per_month",amount+netSalary);

    //  }
     


  }
  useEffect(()=>{
    if(_.get(loanFormDetails,"other_income_list","")){
      try{
        //otherIncome
        const dbother_income_list = JSON.parse(loanFormDetails["other_income_list"]);
        
        if(_.get(dbother_income_list,"length")>0){
          let items = []
          dbother_income_list.forEach((item,index)=>{
            formik.setFieldValue(`other_income_list[${index}].incomeType`, item["incomeType"]);
            formik.setFieldValue(`other_income_list[${index}].amount`, item["amount"]); 
            //formik.values["other_income_lis"][index]["incomeType"] = item["incomeType"]
            items.push(item)
          });
          
          setIncomeFields(items)

        }else{
          setIncomeFields([ { incomeType: "", amount: "" }])
        }
        
      }catch(error){
        setIncomeFields([ { incomeType: "", amount: "" }])
      }

    }else{
      setIncomeFields([ { incomeType: "", amount: "" }])
    }

  },[loanFormDetails])
  useEffect(()=>{
    updateTotalOtherIncomeAmount()

  },other_income_list,handleRemoveIncomeField,handleAddIncomeField)

  const [otherIncomeTypeOptions, setOtherIncomeTypeOptions] =useState([])
  const getMasterData = (category='')=>{
    let postData = {"categories":["md_other_income_types"]};
    
    //values["tenant_id"] = _.get(selectedTenant,"id");
     postMethod(get_master_data,postData).then((res)=>{
      if(category=="md_other_income_types"){  
        
        setOtherIncomeTypeOptions( _.get(res,"result.md_other_income_types",[]).map((item)=>{ item["label"] =  item["name"];return item}))
      }
        
      })
  }
  useEffect(()=>{
    getMasterData("md_other_income_types")
  },[])
  return (
    <div>
      {HBarLabel && <HBar label={HBarLabel} />}
      
     
      <div className="row">
        <div className="col-md-4 mb-2">
          <FormDropdown
            id="otherIncome"
            name="otherIncome"
            label="Other Income"
            options={otherIncomeOptions}
            onChange={(selected) => {
              updateTotalOtherIncomeAmount();
              formik.setFieldValue("otherIncome", selected?.id === true ? "Yes": "No");
            }}
            value={formik.values.otherIncome}
            error={formik.touched.otherIncome && formik.errors.otherIncome}
            onBlur={formik.handleBlur}
          />
          {formik.touched.otherIncome && (
            <ErrorLabel
              name="otherIncome"
              formik={formik}
              message={formik.errors.otherIncome}
            />
          )}
        </div>
        
        {formik.values.otherIncome === "Yes" &&
        <div className="col-md-4 mb-2">
            <FormField
              label="Total Other Income per Month"
              id="total_other_income_per_month"
              name="total_other_income_per_month"
              onChange={(e) => {
                // Handle both direct value changes and selection changes
                const value = e?.label || e?.target?.value || '';
                formik.setFieldValue("total_other_income_per_month", value);
              }}
              value={formik.values.total_other_income_per_month || ''} // Add fallback empty string
              error={formik.touched.total_other_income_per_month && formik.errors.total_other_income_per_month}
              onBlur={formik.handleBlur}
              disableAlphebets={true}
              disableSymbols={true}
              readOnly
              focus={Boolean(formik.values.total_other_income_per_month)}
            />
            {formik.touched.total_other_income_per_month && (
              <ErrorLabel
                name="total_other_income_per_month"
                formik={formik}
                message={formik.errors.total_other_income_per_month}
              />
            )}
        </div>
        }
        </div>
        <div className="row">  
        {formik.values.otherIncome === "Yes" && (
         
         <>
            
           {other_income_list.map((field, index) => (
             <div key={index} className="row align-items-center mb-3">
               <div className="col-md-4 mb-2">
                 
                 <FormDropdown
                     label={`Income Type`}
                     id={`incomeType-${index}`}
                     name={`other_income_list[${index}].incomeType`}
                     value={field.incomeType}
                     options={otherIncomeTypeOptions}
                     onChange={(e) =>
                       handleFieldChange(index, "incomeType", e?.label)
                     }
                     error={
                       formik.touched.other_income_list?.[index]?.incomeType &&
                       formik.errors.other_income_list?.[index]?.incomeType
                     }
                     isImportant={true}
                     onBlur={formik.handleBlur}
                     />
               </div>
               <div className="col-md-4 mb-2">
                 <FormField
                   label={`Amount`}
                   id={`amount-${index}`}
                   name={`other_income_list[${index}].amount`}
                   type="text"
                   value={field.amount}
                   disableAlphebets={true}
                   onChange={(e) =>{
                     handleFieldChange(index, "amount", e.target.value);
                     updateTotalOtherIncomeAmount()

                   }
                   }
                   error={
                     formik.touched.other_income_list?.[index]?.amount &&
                     formik.errors.other_income_list?.[index]?.amount
                   }
                   isImportant={true}
                   onBlur={formik.handleBlur}
                 />
               </div>
               <div className="col-md-4 d-flex justify-content-between align-items-center">
                 {other_income_list.length>1 && (
                   <button
                     type="button"
                     className="btn btn-danger me-2"
                     onClick={() => handleRemoveIncomeField(index)}
                   >
                     Remove
                   </button>
                 )}
                 {index === other_income_list.length - 1 && (
                   <PrimaryButton
                     type="button"
                     onClick={handleAddIncomeField}
                     label="Add Another Type"
                     className="btn btn-primary"
                   />
                 )}
               </div>
             </div>
           ))}
         </>
       )}
       </div>
      
      
    </div>
  );
};